/**
 * Shared Module
 *
 * Contains reusable components, directives, and pipes that are
 * shared across multiple feature modules.
 *
 * This module should be imported by feature modules that need
 * access to shared functionality.
 *
 * Guidelines:
 * - Only include components/directives/pipes that are used in multiple places
 * - Do NOT include services here (use CoreModule for singletons)
 * - Do NOT include feature-specific components
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Migrated Angular components
import { AlertComponent } from './components/alert/alert.component';
// import { LoaderComponent } from './components/loader/loader.component';
// import { SpinnerComponent } from './components/spinner/spinner.component';

// Upgraded AngularJS directives for use in Angular templates
import { AJS_UPGRADED_COMPONENTS } from '../upgrade/ajs-upgraded-components';

@NgModule({
  declarations: [
    // Migrated Angular components
    AlertComponent,
    // LoaderComponent,
    // SpinnerComponent,

    // Upgraded AngularJS components (for use in Angular templates)
    ...AJS_UPGRADED_COMPONENTS,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [
    // Re-export common modules for convenience
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Export shared components
    AlertComponent,
    // LoaderComponent,
    // SpinnerComponent,

    // Export upgraded AngularJS components
    ...AJS_UPGRADED_COMPONENTS,
  ],
})
export class SharedModule {}

